import React from "react";
import { find } from "lodash";

import { Breadcrumbs, StatusTag } from "components";
import { UnderwritingTabs } from "types";

type PropsType = {
	match: {
		isExact?: boolean;
		path: string;
		params: {
			tab?: string;
			id: string;
			underwritingTab?: string;
			applicationId: string;
		};
		url?: string;
	};
	isComparable?: boolean;
	clickOnMatchReport?: Function;
	isBankNotes?: boolean;
	isHighRisk?: string;
};

const UnderwritingBreadcrumbs = ({
	match,
	isComparable,
	clickOnMatchReport,
	isBankNotes,
	isHighRisk,
}: PropsType) => {
	const { params, path } = match;
	const { tab, id, underwritingTab } = params;

	const splitUrl = path.split("/");
	const reportNames = find(
		splitUrl,
		item =>
			item === "merchantMatch" ||
			item === "experian" ||
			item === "owner-gofac" ||
			item === "merchant-gofac" ||
			item === "gverify-result" ||
			item === "tin-check" ||
			item === "owner-gidentify",
	);

	const breadCrumbReportName = (): string => {
		switch (reportNames) {
			case "merchantMatch":
				return "MATCH Report";
			case "experian":
				return "Experian Report";
			case "merchant-gofac":
				return "gOFAC Result - Merchant";
			case "owner-gofac":
				return "gOFAC Result - Owner / Signer";
			case "gverify-result":
				return "gVerify & gAuthenticate Result";
			case "tin-check":
				return "TIN check Result";
			case "owner-gidentify":
				return "gIdentify";
			default:
				return "Report";
		}
	};

	const pages = [
		{
			title: "Underwriting Queue",
			link: "/underwriting/unassigned",
		},
		{
			title: UnderwritingTabs.getByName(tab)?.displayName || "",
			link: `/underwriting/${tab}`,
		},
		{
			title: "Application Info",
			link:
				reportNames && `/underwriting/${tab}/${id}/${underwritingTab}`,
		},
		...(reportNames && !isComparable
			? [
					{
						title: breadCrumbReportName(),
					},
			  ]
			: []),
		...(reportNames && isComparable
			? [
					{
						title: breadCrumbReportName(),
						link: `/underwriting/${tab}/${id}/${underwritingTab}/${reportNames}`,
						onClick: clickOnMatchReport,
					},
					{
						title: "Comparison Page",
					},
			  ]
			: []),
	];

	const breadcrumbsLabels = (
		<>
			{isBankNotes && (
				<StatusTag
					value="Bank Notes"
					className="ml-4"
					variant="warning"
					icon="alert"
				/>
			)}
			{isHighRisk === "true" && (
				<StatusTag
					value="High Risk"
					className="ml-4"
					icon="circle-alert"
				/>
			)}
			{tab === "pended" && (
				<StatusTag
					value="Pended"
					className="ml-4"
					variant="warning"
					icon="clock"
				/>
			)}
		</>
	);

	return <Breadcrumbs pages={pages} component={breadcrumbsLabels} />;
};

export default UnderwritingBreadcrumbs;
